module.exports = __webpack_public_path__ + "img/sig.4667b2eb.png";